import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import directives from './directives/'
import 'tailwindcss/tailwind.css'
import './scss/index.scss'
import { setupSentry } from './plugins/setupSentry'

const app = createApp(App)
  .use(store)
  .use(router)
  .use(directives)
  .mount('#app')

setupSentry(app, router, process.env.NODE_ENV as string)
